import React from 'react';

export default () => (
  <svg
    fill="none"
    height="30"
    style={{ width: 25 }}
    viewBox="0 0 19 30"
    width="19"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1333 2H5.46667C3.55208 2 2 3.55208 2 5.46667V24.5333C2 26.4479 3.55208 28 5.46667 28H14.1333C16.0479 28 17.6 26.4479 17.6 24.5333V5.46667C17.6 3.55208 16.0479 2 14.1333 2Z"
      stroke="#44454A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
    <path
      d="M2 21.6444H17.6"
      stroke="#44454A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
  </svg>
);
